import React from 'react';
import natureModel from './model/natureModel';
import { SelectBasePrototype } from 'clad';

const SelectNature = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder } = props;

    const handleFetch = ({ query, id, pagination }) =>
        natureModel.list({ query, id, pagination });

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a nature')}
            schema={{ idOption: 'mid', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
        />
    );
});

export default SelectNature;
